/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useEffect, useState} from "react";
import {Button, Form, Tooltip} from "antd";
import MapPropsContext from "../MapPropsContext";
import useInputs from "../../../utils/hooks/useInputs";

import "./WidgetSearchByLonLatitude.scss";

function WidgetSearchByLonLatitude() {
  const {
    setMapCenter,
    widgetState,
  } = useContext(MapPropsContext);

  const [isLoading, setIsLoading ] = useState(true);

  const [inputsState, onChange] = useInputs({
    'latitude': '',
    'longitude': '',
  });
  const {latitude, longitude} = inputsState;

  const moveToPosition = useCallback(() => {
    setMapCenter({ latitude, longitude, zoom: 14 });
  }, [latitude, longitude, setMapCenter]);

  useEffect(() => {
    const { search_latitude, search_longitude } = widgetState;

    if(search_latitude && search_longitude && longitude.length > 0 && latitude.length > 0)
      setIsLoading(false);
  }, [latitude, longitude, widgetState]);

  return (
      <Form.Item>
        <PointInput name="latitude"
                    tooltip="위도를 입력하세요."
                    onChange={onChange} />
        <PointInput name="longitude"
                    tooltip="경도를 입력하세요."
                    onChange={onChange} />
        <Button type={"primary"}
                disabled={ isLoading}
                onClick={moveToPosition}
                style={{ width: '100%' }}>
          이동하기
        </Button>
      </Form.Item>
  );
}


function PointInput({ name, tooltip, regex, onChange  }) {
  const [inputsState, onChangeField] = useInputs({ field1: '', field2: '', field3: '' });
  const { field1, field2, field3 } = inputsState;

  const { onChangeWidgetState } = useContext(MapPropsContext);

  useEffect(() => {
    const point = (parseFloat(field1) || 0) + (parseFloat(field2) / 60 || 0) + (parseFloat(field3) / 3600 || 0);
    if ( point !== 0 ) {
      onChange({ target: { name, value: String(point) }});
    }
    else {
      onChange({target: {name, value: ''}});
    }
    if( point !== 0 && field1.length > 0 && field2.length > 0 && field3.length > 0){
      onChangeWidgetState({
        target: {
          name: `search_${name}`,
          value: true,
        }
      });
    }
  }, [field1, field2, field3]);

  return (
    <span className={"ant-input-affix-wrapper"}>
      <Tooltip title={tooltip} placement={"bottom"}>
        <div className={["point-field", "ant-input"].join(" ")}>
          <input type="text"
                 name="field1"
                 maxLength={9} size={9}
                 value={field1}
                 onChange={onChangeField}
                 style={{ border: 0, width: '6em' }} />
          {"°"}
          <input type="text"
                 name="field2"
                 maxLength={6} size={6}
                 value={field2}
                 onChange={onChangeField}
                 style={{ border: 0, width: '4em' }} />
          {"'"}
          <input type="text"
                 name="field3"
                 maxLength={6} size={6}
                 value={field3}
                 onChange={onChangeField}
                 style={{ border: 0, width: '4em' }} />
          {"\""}
        </div>
      </Tooltip>
    </span>
  );
}


export default WidgetSearchByLonLatitude;
